import { lazy } from 'react';
import './index.css';
import './styles/styles.scss';
import { usewpdataSelectors } from './lib/wpdataState/selectors';
import Header from './components/Header/Header';
import FloatingCTA from './components/Floater/Floater';
import Support from './components/Zendesk';
import LazyComponent from './components/LazyLaod';
import { useState, useEffect } from 'react';

const Layout = () => {
  const { Layout, Theme } = usewpdataSelectors();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 500);
    };
    checkScreenSize();

    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <>
      <div
        style={{
          '--button-custom-background': Theme?.customButton?.background,
          '--button-custom-backgroundHover': Theme?.customButton?.backgroudHover,
          '--button-custom-borderColor': Theme?.customButton?.borderColor,
          '--button-custom-textColor': Theme?.customButton?.textColor,
        }}
      >
        <div style={{ width: '100%' }}>
          <Header />
        </div>
        {Layout?.hero?.display && (
          <LazyComponent Component={lazy(() => import('./components/ProductHero/ProductHero'))} />
        )}

        {Layout?.promotional?.display && (
          <LazyComponent Component={lazy(() => import('./components/PromotionalSection/PromotionalSection'))} />
        )}
        {Layout?.ribbon?.display && (
          <LazyComponent Component={lazy(() => import('./components/SlidingTextBar/SlidingTextBar'))} />
        )}
        {Layout?.about?.display && (
          <LazyComponent Component={lazy(() => import('./components/AboutSection/AboutSection'))} />
        )}
        {Layout?.usage?.display && (
          <LazyComponent Component={lazy(() => import('./components/UsageSection/UsageSection'))} />
        )}
        {Layout?.ribbon?.display && (
          <LazyComponent Component={lazy(() => import('./components/SlidingTextBar/SlidingTextBar'))} />
        )}

        {Layout?.testimonialsSlider?.display && (
          <LazyComponent Component={lazy(() => import('./components/TestimonialsSwiper/TestimonialSwiper'))} />
        )}

        {Layout?.faq?.display && <LazyComponent Component={lazy(() => import('./components/FAQ/FAQ'))}></LazyComponent>}
        {Layout?.reviews?.display && <LazyComponent Component={lazy(() => import('./components/CustomerReviews'))} />}

        <LazyComponent Component={lazy(() => import('./components/Footer/Footer'))} />
        {Layout?.floater?.display && isMobile && <FloatingCTA />}
        <div>
          <Support />
        </div>
      </div>
    </>
  );
};

export default Layout;
